import React from 'react';
import { StyledContainer } from './ElementContainer.styles';

const ElementContainer = ({ children }) => <StyledContainer>{children}</StyledContainer>;

export default ElementContainer;
